/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-delivery-endpoints-searchview-component.js
 *
 * Created by randysorensen on 5/9/17.
 */

'use strict';

function PartnerDeliveryEndpointsSearchViewController(_, $location, uiGridConstants, PartnerEditService,
		PartnerResourceFactory, ModalService, NavbarUtilService, NotificationService) {

	var self = this;


	//======//
	// Data //
	//======//

	var queryForGridData = function () {
		self.loadingIndicator.show = true;

		PartnerEditService
			.getDeliveryEndpointSearchViewData(self.showHidden)
			.then(function (deliveryEndpointsData) {
				self.gridOptions.data = deliveryEndpointsData.deliveryEndpoints;
				self.partnerObject = deliveryEndpointsData.partnerObject;
				self.searchText = $location.search().searchText || null;
				self.filterGrid(self.searchText);

				self.loadingIndicator.show = false;
			});
	};


	//=================//
	// Lifecycle Hooks //
	//=================//

	self.$onInit = function () {
		self.showHidden = false;
		if (self.canRead) {
			queryForGridData();

			// Navbar search button click handler
			NavbarUtilService.viewSearchFunction = queryForGridData;
		}
	};


	//==========//
	// Pacifier //
	//==========//

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};


	//======//
	// Grid //
	//======//

	self.gridApi = null;
	self.searchText = null;

	self.gridColumnDefs = [
		{
			field: 'name',
			type: 'string',
			width: '*',
			sort: {
				direction: 'asc',
				priority: 2
			},
			displayName: 'Endpoint Name'
		},
		{
			field: 'type',
			type: 'string',
			width: '*',
			sort: {
				direction: 'asc',
				priority: 1
			},
			displayName: 'Type',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
			cellFilter: 'deliveryEndpointTypeLabel : grid.appScope.$ctrl',
		}
	];

	self.gridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: false,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		multiSelect: false,
		columnDefs: self.gridColumnDefs,
		onRegisterApi: function(gridApi) {
			self.gridApi = gridApi;
			self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
		},
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
		data: []
	};

	self.onRowDblClick = function (row) {
		self.editDeliveryEndpoint(row.entity);
	};

	self.filterGrid = function (searchText) {
		if (searchText !== null) {
			self.searchText = searchText.toLowerCase();
			self.gridApi.grid.refresh();
		}
	};

	self.processGridFilter = function (renderableRows) {
		renderableRows.forEach(function (row) {
			row.visible = (self.searchText === null)?
				true:
				row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
		});
		return renderableRows;
	};

	var getSelectedDeliveryEndpoint = function () {
		return self.gridApi.selection.getSelectedRows()[0];
	};

	self.getEndpointTypeLabel = PartnerEditService.getEndpointTypeLabel;


	//===========================//
	// Delivery Endpoint Actions //
	//===========================//

	var endpointTypeIsSupported = function (endpoint) {
		return !!endpoint && _.includes(_.keys(PartnerEditService.supportedEndpointTypes), endpoint.type);
	};

	self.newDeliveryEndpoint = function (type) {
		$location.url(
			'/system/partners/edit/' + self.partnerObject.id +
			'/deliveryendpoints/' + type.toLowerCase() +
			'/edit/-1');
	};

	self.editDeliveryEndpoint = function (endpoint) {
		if (endpoint.hidden) {
			NotificationService.createWarningNotification('"' + endpoint.name + '" is hidden');
		} else if (!endpointTypeIsSupported(endpoint)) {
			NotificationService.createWarningNotification(endpoint.type + ' endpoints are not yet editable');
		} else {
			$location.url(
				'/system/partners/edit/' + self.partnerObject.id +
				'/deliveryendpoints/' + endpoint.type.toLowerCase() +
				'/edit/' + endpoint.id);
		}
	};

	self.cloneSelectedDeliveryEndpoint = function () {
		var endpoint = getSelectedDeliveryEndpoint();
		if (!endpointTypeIsSupported(endpoint)) {
			NotificationService.createWarningNotification(endpoint.type + ' endpoints cannot yet be cloned');
		} else {
			self.loadingIndicator.show = true;

			PartnerResourceFactory
				.cloneDeliveryEndpoint({partnerId: self.partnerObject.id, endpointId: endpoint.id})
				.$promise.then(function () {
				self.gridApi.selection.clearSelectedRows();
				queryForGridData();

				// LI should already be hidden by
				// queryForGridData()
				self.loadingIndicator.show = false;
			});
		}
	};

	self.toggleSelectedDeliveryEndpointVisibility = function () {
		self.loadingIndicator.show = true;

		var endpointId = getSelectedDeliveryEndpoint().id;
		PartnerResourceFactory
			.deleteDeliveryEndpoint({id: endpointId})
			.$promise.then(function () {
				self.gridApi.selection.clearSelectedRows();
				queryForGridData();

				// LI should already be hidden by
				// queryForGridData()
				self.loadingIndicator.show = false;
			});
	};

	var showConfirmationModal = function (action, handler) {
		var capitalizedAction = action[0].toUpperCase() + action.slice(1);
		ModalService.showMessageModal({
				messageText: 'Are you sure you want to ' + action +
							 ' "' + getSelectedDeliveryEndpoint().name + '"?',
				title: capitalizedAction + ' Partner Delivery Endpoint',
				windowClass: 'confirm-modal-sm',
				showOK: true,
				okText: 'Yes',
				pullCancelLeft: true
			},
			function () { handler(); },
			function () {}
		);
	};


	//=========//
	// Toolbar //
	//=========//

	// Toolbar buttons
	self.toolbarButtonDefs = [
		{
			label: 'New',
			enabled: function () { return self.canWrite; },
			onClick: function () {
				ModalService.showNewDeliveryEndpointModal(
					_.keys(PartnerEditService.supportedEndpointTypes),
					self.newDeliveryEndpoint);
			},
		},
		{
			label: 'Edit',
			enabled: function () { return self.gridApi.selection.getSelectedCount() === 1 && self.canWrite; },
			onClick: function () { self.editDeliveryEndpoint(getSelectedDeliveryEndpoint()); },
		},
		{
			label: 'Clone',
			enabled: function () { return self.gridApi.selection.getSelectedCount() === 1 && self.canWrite; },
			onClick: function () { showConfirmationModal('clone', self.cloneSelectedDeliveryEndpoint); },
		},
		{
			label: 'Hide',
			enabled: function () {
				return self.gridApi.selection.getSelectedCount() === 1 &&
					!getSelectedDeliveryEndpoint().hidden && self.canWrite;
			},
			onClick: function () { showConfirmationModal('hide', self.toggleSelectedDeliveryEndpointVisibility); },
		},
		{
			label: 'Unhide',
			enabled: function () {
				return self.gridApi.selection.getSelectedCount() === 1 &&
					getSelectedDeliveryEndpoint().hidden && self.canWrite;
			},
			onClick: function () { showConfirmationModal('unhide', self.toggleSelectedDeliveryEndpointVisibility); },
		}
	];

	self.checkboxDefs = [
		{
			label: 'Show Hidden',
			onUpdate: function (newValue) {
				self.showHidden = newValue;
				queryForGridData();
			},
			isChecked: self.showHidden,
		},
	];

}

angular.module('prism-ui.partner').component('partnerDeliveryEndpointsSearchView', {
	templateUrl: 'system/partner/editor/components/view/deliveryEndpoints/searchView/partner-delivery-endpoints-searchview-template.html',
	controller: PartnerDeliveryEndpointsSearchViewController,
	bindings: {
		canRead: '<',
		canWrite: '<'
	}
})
.filter('deliveryEndpointTypeLabel', function () {
	return function (endpointType, $ctrl) {
		return $ctrl.getEndpointTypeLabel(endpointType);
	};
});

